import axios from "axios";
function formatDate(date) {

    const d = new Date(date)

    const day = d.getDate()
    const month = d.toLocaleString("default", { month: "long" })
    const year = d.getFullYear()

    const suffix = getOrdinal(day)

    return `${day}${suffix} ${month} ${year}`
}

function getOrdinal(n) {

    if (n > 3 && n < 21) return "th"

    switch (n % 10) {
        case 1: return "st"
        case 2: return "nd"
        case 3: return "rd"
        default: return "th"
    }

}

export function payWithPaystack({ channel, data, user, router, toast, amount})  {

    const handler = window.PaystackPop.setup({

        key: channel.public_key,
        email: user.email,
        amount: amount * 100,
        currency: "NGN",
        ref: "PS-" + Date.now(),

        callback: (response) => {

            axios.post("/payment/verify-paystack-payment", {
                reference: response.reference,
                plan_detail_id: data.id,
                payment_channel_id: channel.id
            })
            .then(res => {

                if(res.data.data.data.status == 'success'){

                    router.push({
                        path: "/payment-success",
                        query: {
                            ref: res.data.data.data.reference,
                            amount: res.data.data.data.amount,
                            plan: "Subscription Plan - " + data.name,
                            expiry: formatDate(res.data.data.subscription.expiry_date)
                        }
                    })

                } else {

                    toast.error(res.data.message || "Payment verification failed")
                }


            })
            .catch(error => {
                console.log("FULL ERROR:", error)
                toast.error(error?.response?.data?.message || "Payment failed")
            })

        }

    })

    handler.openIframe()

}